import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Cruz, FlechaIzq, Marca } from './Iconos';

/** Cabecera con la marca. `accion` es el enlace de la derecha. */
export function CabeceraMarca({ accion }: { accion?: { a: string; texto: string } }) {
  return (
    <header className="cabecera">
      <Link to="/" className="cabecera__marca" aria-label="MentorKing, inicio">
        <Marca />
        <span>MentorKing</span>
      </Link>
      {accion && (
        <Link to={accion.a} className="cabecera__enlace">
          {accion.texto}
        </Link>
      )}
    </header>
  );
}

/** Cabecera de un paso, con botón para volver. */
export function CabeceraPaso({
  volverA,
  volverTexto,
  antetitulo,
  titulo,
  derecha,
}: {
  volverA: string;
  volverTexto: string;
  antetitulo?: string;
  titulo: string;
  derecha?: ReactNode;
}) {
  return (
    <header className="cabecera">
      <div className="cabecera__titulo">
        <Link to={volverA} className="volver" aria-label={volverTexto}>
          <FlechaIzq />
        </Link>
        <div>
          {antetitulo && <div className="antetitulo">{antetitulo}</div>}
          <h1 className="titulo titulo--sub">{titulo}</h1>
        </div>
      </div>
      {derecha}
    </header>
  );
}

export function Cargando({ texto = 'Cargando…' }: { texto?: string }) {
  return (
    <div className="cargando" role="status">
      <span className="giro" aria-hidden="true" />
      {texto}
    </div>
  );
}

/** Un error que el cliente tiene que ver. role=alert: los lectores de pantalla lo anuncian. */
export function AvisoError({ children }: { children: ReactNode }) {
  return (
    <div className="aviso aviso--error" role="alert">
      <Cruz tam={16} />
      <div>{children}</div>
    </div>
  );
}

/** Las barritas de "cambios disponibles". */
export function Cambios({ restantes, total }: { restantes: number; total: number }) {
  return (
    <span className="cambios">
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={`cambios__barra ${i < restantes ? 'cambios__barra--disponible' : ''}`} />
      ))}
      <span style={{ marginLeft: 3 }}>
        {restantes} de {total}
      </span>
    </span>
  );
}
